<i18n src="./resources/locales.json"></i18n>

<template>
  <v-tooltip :content-class="tooltipContentClass" color="secondary" top>
    <template v-slot:activator="{ on }">
      <v-textarea
        ref="conversationInputField"
        v-model="message"
        class="conversation-input-field"
        :class="{ disabled }"
        :autofocus="autofocus"
        :auto-grow="true"
        :clearable="false"
        :rows="1"
        :placeholder="placeholder"
        :disabled="disabled"
        :dark="$vuetify.theme.dark"
        v-on="on"
        @focus="focusHandler"
        @blur="blurHandler"
        @keyup="keyUpHandler"
        @keyup.up="arrowUpHandler"
        @keydown.enter.prevent="sendMessage"
      >
        <template #append>
          <slot name="append" />
          <v-tooltip bottom>
            <template v-slot:activator="{ on2 }">
              <v-btn :ripple="false" icon height="40" width="40" @click="sendMessage" v-on="on2">
                <v-icon>mdi-send</v-icon>
              </v-btn>
            </template>
            <span v-once>{{ $t(iconTooltip) }}</span>
          </v-tooltip>
        </template>
      </v-textarea>
    </template>
    <span v-once>{{ $t('tooltips.limitReached') }}</span>
  </v-tooltip>
</template>

<script>
const MAX_LENGTH = 1900;

export default {
  name: 'EcsSubmitInput',

  props: {
    autofocus: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: ''
    },
    disableMultilineShadow: {
      type: Boolean,
      default: false
    },
    iconTooltip: {
      type: String,
      default: 'tooltips.send'
    }
  },

  data() {
    return {
      message: '',
      lastMessage: '',
      maxLengthReached: false
    };
  },

  computed: {
    tooltipContentClass() {
      return 'tooltip-chat-input ' + (this.maxLengthReached ? 'tooltip-chat-input-visible' : '');
    }
  },

  watch: {
    message() {
      this.$emit('onChange', this.message);
    }
  },

  mounted() {
    setTimeout(this.$refs.conversationInputField.calculateInputHeight, 100);
  },

  methods: {
    arrowUpHandler() {
      if (this.message.length < 1) {
        this.message = this.lastMessage;
      }
    },

    blurHandler() {
      this.$emit('onBlur');
    },

    focusHandler() {
      this.$emit('onFocus');
    },

    focus() {
      this.$refs.conversationInputField.focus();
    },

    async processMultilineInput() {
      if (this.disableMultilineShadow) {
        return;
      }
      const inputContainer = this.$refs.conversationInputField.$el;
      const textarea = inputContainer.querySelector('textarea');
      const lines = (textarea.scrollHeight - 30) / 18;
      if (lines > 1) {
        inputContainer.classList.add('multiple-lines');
      } else {
        inputContainer.classList.remove('multiple-lines');
      }
      if (this.message.length > MAX_LENGTH) {
        this.maxLengthReached = true;
        const cursorPos = textarea.selectionStart;
        this.message = this.message.substring(0, MAX_LENGTH);
        await this.$nextTick();
        textarea.selectionStart = cursorPos;
        textarea.selectionEnd = cursorPos;
      } else {
        this.maxLengthReached = false;
      }
    },

    async setMessage(message) {
      this.message = message;
      this.$refs.conversationInputField.focus();
      await this.$nextTick();
      this.processMultilineInput();
    },

    sendMessage() {
      this.$emit('onSubmit', this.message);
      this.lastMessage = this.message;
      this.message = '';
    },

    keyUpHandler() {
      this.processMultilineInput();
    }
  }
};
</script>

<style src="./scoped.css" scoped />
<style src="./global.css" />
